import { render, staticRenderFns } from "./ThemeItem.vue?vue&type=template&id=2d60d35a&scoped=true&"
import script from "./ThemeItem.vue?vue&type=script&lang=ts&"
export * from "./ThemeItem.vue?vue&type=script&lang=ts&"
import style0 from "./ThemeItem.vue?vue&type=style&index=0&id=2d60d35a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d60d35a",
  null
  
)

export default component.exports